/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ItemVariantGroupsItemVariantGroupIdAssociationTypesPut$Params {
  'Active-Tenant-Identifier': string;
  itemVariantGroupId: string;
      body: Array<string>
}

export function itemVariantGroupsItemVariantGroupIdAssociationTypesPut(http: HttpClient, rootUrl: string, params: ItemVariantGroupsItemVariantGroupIdAssociationTypesPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, itemVariantGroupsItemVariantGroupIdAssociationTypesPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('itemVariantGroupId', params.itemVariantGroupId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

itemVariantGroupsItemVariantGroupIdAssociationTypesPut.PATH = '/item-variant-groups/{itemVariantGroupId}/association/types';
